<fieldset class="group" [formGroup]="group()">
    <legend>{{ "FLIGHT_LIST.groups.leg" | translate }}</legend>
    @if (groundRun()) {
        <div class="fields single">
            <label class="field">
                <span class="label required">{{ "FLIGHT_LIST.edit.groundRun.location" | translate }}</span>
                <kendo-combobox
                    formControlName="departureId"
                    [data]="departures()"
                    textField="label"
                    valueField="id"
                    [valuePrimitive]="true"
                    [kendoDropDownFilter]="{ operator: 'contains' }"
                ></kendo-combobox>
                <!-- Code, city and name of the airport chosen, as the app shows them under the field. -->
                @if (departure(); as airport) {
                    <dl class="airport">
                        @if (airport.code) {
                            <dt>{{ "FLIGHT_LIST.airport.code" | translate }}</dt>
                            <dd>{{ airport.code }}</dd>
                        }
                        @if (airport.city) {
                            <dt>{{ "FLIGHT_LIST.airport.city" | translate }}</dt>
                            <dd>{{ airport.city }}</dd>
                        }
                        @if (airport.name) {
                            <dt>{{ "FLIGHT_LIST.airport.name" | translate }}</dt>
                            <dd>{{ airport.name }}</dd>
                        }
                    </dl>
                }
                @if (group().controls.departureId.invalid) {
                    <span class="error">{{ "FLIGHT_LIST.edit.errors.required" | translate }}</span>
                }
            </label>
        </div>
    } @else {
        <div class="fields pairs">
            <label class="field">
                <span class="label required">{{ "FLIGHT_LIST.from" | translate }}</span>
                <kendo-combobox
                    formControlName="departureId"
                    [data]="departures()"
                    textField="label"
                    valueField="id"
                    [valuePrimitive]="true"
                    [kendoDropDownFilter]="{ operator: 'contains' }"
                ></kendo-combobox>
                <!-- Code, city and name of the airport chosen, as the app shows them under the field. -->
                @if (departure(); as airport) {
                    <dl class="airport">
                        @if (airport.code) {
                            <dt>{{ "FLIGHT_LIST.airport.code" | translate }}</dt>
                            <dd>{{ airport.code }}</dd>
                        }
                        @if (airport.city) {
                            <dt>{{ "FLIGHT_LIST.airport.city" | translate }}</dt>
                            <dd>{{ airport.city }}</dd>
                        }
                        @if (airport.name) {
                            <dt>{{ "FLIGHT_LIST.airport.name" | translate }}</dt>
                            <dd>{{ airport.name }}</dd>
                        }
                    </dl>
                }
                @if (group().controls.departureId.invalid) {
                    <span class="error">{{ "FLIGHT_LIST.edit.errors.required" | translate }}</span>
                }
            </label>
            <label class="field">
                <span class="label required">{{ "FLIGHT_LIST.to" | translate }}</span>
                <kendo-combobox
                    formControlName="arrivalId"
                    [data]="arrivals()"
                    textField="label"
                    valueField="id"
                    [valuePrimitive]="true"
                    [kendoDropDownFilter]="{ operator: 'contains' }"
                ></kendo-combobox>
                @if (arrival(); as airport) {
                    <dl class="airport">
                        @if (airport.code) {
                            <dt>{{ "FLIGHT_LIST.airport.code" | translate }}</dt>
                            <dd>{{ airport.code }}</dd>
                        }
                        @if (airport.city) {
                            <dt>{{ "FLIGHT_LIST.airport.city" | translate }}</dt>
                            <dd>{{ airport.city }}</dd>
                        }
                        @if (airport.name) {
                            <dt>{{ "FLIGHT_LIST.airport.name" | translate }}</dt>
                            <dd>{{ airport.name }}</dd>
                        }
                    </dl>
                }
                @if (group().controls.arrivalId.invalid) {
                    <span class="error">{{ "FLIGHT_LIST.edit.errors.required" | translate }}</span>
                }
            </label>
        </div>
    }
</fieldset>
